module.exports = __webpack_public_path__ + "img/modal-download.72b7ad96.svg";